module.exports = __webpack_public_path__ + "img/高交会.0234b10f.jpg";